import { fetchPost } from '../Service/ApiService'

export const bulkSendPurchaseDetails = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`purchasepartnersdetails/bulksend`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};

export const bulkRejectPurchaseDetails = (selectedIds, resolve, reject) => {
   

    try {
        fetchPost(`purchasepartnersdetails/bulkreject`, selectedIds, {
            success: (res) => { resolve(res) },
            fail: (res) => { reject(res) },
            error: (err) => {
                reject({ status: false, message: "Unable to connect server" })
            }
        })
    } catch (e) {
        reject({ status: false, message: "Unable to process operation" })
    }
};






